var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRerunIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "#1F36C7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3890_26257)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0009 4.44434C13.0692 4.44434 15.5564 6.93156 15.5564 9.99989C15.5564 13.0682 13.0692 15.5554 10.0009 15.5554C7.11977 15.5554 4.75102 13.3625 4.47266 10.5547C4.44239 10.2493 4.69404 9.99989 5.00087 9.99989C5.30769 9.99989 5.55278 10.2499 5.59068 10.5543C5.86361 12.7472 7.73419 14.4443 10.0009 14.4443C12.4553 14.4443 14.4453 12.4543 14.4453 9.99989C14.4453 7.54545 12.4553 5.55545 10.0009 5.55545C8.63198 5.55545 7.40753 6.17434 6.59253 7.14711L7.06735 7.62193C7.32984 7.88442 7.14393 8.33322 6.77272 8.33322H5.27864C4.81841 8.33322 4.44531 7.96013 4.44531 7.49989V6.00552C4.44531 5.63435 4.89404 5.44843 5.15655 5.71084L5.80476 6.35878C6.82309 5.18656 8.32531 4.44434 10.0009 4.44434Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3890_26257"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.3333,
    height: 13.3333,
    fill: "white",
    transform: "translate(3.33301 3.3335)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRerunIcon);
export default __webpack_public_path__ + "static/media/rerun-icon.4d5efa1dc010de274840206c87b17331.svg";
export { ForwardRef as ReactComponent };